var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueIron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ironing",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.105,
    height: 26.105,
    viewBox: "0 0 26.105 26.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M364.977,6.118h.766a.765.765,0,0,0,.765-.765h1.531a.765.765,0,0,0,0-1.53h-1.531V2.294h1.531a.765.765,0,0,0,0-1.53h-1.531A.765.765,0,0,0,365.743,0h-.766a3.059,3.059,0,0,0,0,6.118Z",
    transform: "translate(-343.465)",
    fill: "#5861ae"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M51.078,55.131a2.294,2.294,0,0,0-.258-4.574H32.176a2.014,2.014,0,1,1,0-4.028H44A4.595,4.595,0,0,1,44,45H32.176a3.543,3.543,0,1,0,0,7.087H50.82a.765.765,0,1,1,0,1.53H43.382A15.78,15.78,0,0,0,28.463,64.273H53.115a13.971,13.971,0,0,0-.032-2.445Zm-2.7,7.663h-9.8a.765.765,0,0,1-.669-.395l-1.53-2.769a.765.765,0,0,1,.264-1.019,12.712,12.712,0,0,1,6.739-1.936h4.133a.765.765,0,0,1,.752.624l.861,4.589A.765.765,0,0,1,48.376,62.794Z",
    transform: "translate(-27.012 -42.706)",
    fill: "#5861ae"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M222.363,304a11.174,11.174,0,0,0-5.3,1.34l.95,1.719h8.425L225.862,304Z",
    transform: "translate(-205.993 -288.5)",
    fill: "#5861ae"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M.739,454.48a.764.764,0,0,0,.026,1.528H25.338a.765.765,0,0,0,.765-.765V453H1.011q-.17.727-.273,1.48Z",
    transform: "translate(0 -429.904)",
    fill: "#5861ae"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueIron);
export default __webpack_public_path__ + "static/media/blueIron.70cc1950c892aafeb0c99482cc76a9da.svg";
export { ForwardRef as ReactComponent };